<template>
  <pt-group-form ref="form" class="pt-group-form__withData" :is-edit="isEdit" :id="id" :form="groupDetail" :table-data="tableData" v-loading="detailLoading"
                 @changeSort="changeSort"></pt-group-form>
</template>

<script>
import PtGroupForm from './form'
export default {
  name: 'pt-group-form__withData',
  components: {
    'pt-group-form': PtGroupForm
  },
  computed: {
    form () {
      return this.$refs.form
    }
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      groupDetail: {},
      tableData: [],
      detailLoading: false
    }
  },
  methods: {
    // 新建/编辑group的排序枚举和商品列表枚举的转换
    // 获取分组详情
    goodsGroupDetail () {
      this.detailLoading = true
      this.$store.dispatch('goodsGroupDetail', this.id).then(data => {
        this.detailLoading = false
        data.visible_show = data.visible + ''
        this.groupDetail = data
      }).catch(err => {
        this.detailLoading = false
        this.$message.error(err || '获取分组信息失败')
      })
    },
    editApi (data) {
      this.$emit('submitLoad', true)
      this.$store.dispatch('groupEdit', data).then(data => {
        this.$message.success('编辑分组成功')
        history.go(-1)
        this.$emit('submitLoad', false)
      }).catch(err => {
        this.$message.error(err || '编辑分组失败')
        this.$emit('submitLoad', false)
      })
    },
    new (data) {
      this.$emit('submitLoad', true)
      this.$store.dispatch('newGoodsGroup', data).then(data => {
        this.$message.success('新建分组成功')
        history.go(-1)
        this.$emit('submitLoad', false)
        // doing something ...
      }).catch(errorMessage => {
        this.$emit('submitLoad', false)
        this.$message.error(errorMessage || '新建分组失败')
      })
    },
    submit () {
      this.form.validate().then(formValue => {
        formValue.visible = formValue.visible_show === 'true'
        // formValue.visible_show && this.$delete(formValue, 'visible_show')
        if (this.isEdit) {
          this.editApi(formValue)
        } else {
          this.new(formValue)
        }
      })
    },
    cancel () {
      history.go(-1)
    }
  },
  created () {
    if (this.isEdit) {
      this.goodsGroupDetail()
    }
  }
}
</script>
